import { useContext } from 'react';

import { EntityContext } from '../context';

// ----------------------------------------------------------------------

export const useEntityContext = () => {
  const context = useContext(EntityContext);

  if (!context) throw new Error('useEntityContext must be use inside EntityProvider');

  return context;
};
